import React from 'react';
import { Divider, Typography } from '@mui/material';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';

export default function RoleRelationSection({
  title,
  rows = [],
  columns = [],
  fileNameExport
}) {
  return (
    <>
      <br />
      <Divider>
        <Typography style={{ fontWeight: 'bold', color: 'black', width: '100%', fontStyle: 'italic' }}>
          <span>{title}</span>
        </Typography>
      </Divider>
      <br />
      <br />
      {rows.length > 0 && (
        <DataGridGenerico
          columns={columns}
          fileNameExport={fileNameExport}
          rows={rows}
          toolbar={false}
          totalCount={rows.length}
        />
      )}
    </>
  );
}
